import type {Decision} from './model'

type Answer={option?:string;custom?:string}
type SavedThread={parent_job:string;saved_answers?:Record<string,unknown>;decisions:Decision[];messages:{parent_job?:string;role:string;answers?:Record<string,unknown>}[]}

// A discussion saves validated answers in its user message, not human_response.
// Restore those receipts as editable choices; this never approves a work stage.
export function restoreDecisionAnswers(thread:SavedThread):Record<string,Answer>{
 const merged:Record<string,unknown>=Object.assign(Object.create(null),thread.saved_answers??{})
 for(const message of thread.messages){
  if(message.role==='user'&&message.parent_job===thread.parent_job){
   for(const [id,value] of Object.entries(message.answers??{}))merged[id]=value
  }
 }
 return Object.fromEntries((thread.decisions??[]).flatMap<[string,Answer]>(d=>{
  if(!d||typeof d.id!=='string'||!Array.isArray(d.options))return []
  const raw=merged[d.id];if(!raw||typeof raw!=='object')return []
  const answer=raw as Answer
  if(typeof answer.custom==='string'&&answer.custom.trim())return [[d.id,{custom:answer.custom}]]
  if(typeof answer.option==='string'&&d.options.some(o=>o?.id===answer.option))return [[d.id,{option:answer.option}]]
  return []
 }))
}
